import Constants from '../actions/types';

const initialState = {
  pair: null,
  pairs: [],
  loading: false,
  message: null,
  severity: null
};

const loggedPairsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.LOGGED_PAIRS_GET_REQUEST: {
      const newState = {
        ...state,
        pair: null,
        pairs: [],
        loading: true
      };

      return newState;
    }

    case Constants.LOGGED_PAIRS_GET_SUCCESS: {
      const pairs = action.payload;
      const newState = {
        ...state,
        pair: null,
        pairs: pairs,
        loading: false
      };

      return newState;
    }

    case Constants.LOGGED_PAIRS_GET_FAILURE: {
      const newState = {
        ...state,
        pair: null,
        pairs: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.LOGGED_PAIRS_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    case Constants.LOGGED_RECORDPAIR_GET_REQUEST: {
      const newState = {
        ...state
      };

      return newState;
    }

    case Constants.LOGGED_RECORDPAIR_GET_SUCCESS: {
      const newState = {
        ...state,
        pair: action.payload
      };
      return newState;
    }

    case Constants.LOGGED_RECORDPAIR_GET_FAILURE: {
      const newState = {
        ...state,
        pair: null,
        message: action.payload,
        severity: 'error'
      };
      return newState;
    }

    default: {
      return state;
    }
  }
};

export default loggedPairsReducer;
